export const module = {
  info: {
    name: 'voip-vos-server',
    caption: 'Vos Server',
    viewGroup: 'servers-modules'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    notAllowedProfiles: [],
    topSeparator: false,
    caption: 'VOS Server',
    icon: 'el-icon-bank-card',
    routeName: 'module->voip-vos-server->create',
    children: [
      {
        caption: 'Create Entity',
        icon: 'el-icon-plus',
        routeName: 'module->voip-vos-server->create'
      },
      {
        caption: 'List Entities',
        icon: 'el-icon-more-outline',
        routeName: 'module->voip-vos-server->list->page',
        routeParams: { listPage: 1}
      }
    ]
  }
}

export default module
